import { render, staticRenderFns } from "./ProfileStack.vue?vue&type=template&id=047c68b8&scoped=true"
import script from "./ProfileStack.vue?vue&type=script&lang=js"
export * from "./ProfileStack.vue?vue&type=script&lang=js"
import style0 from "./ProfileStack.vue?vue&type=style&index=0&id=047c68b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c68b8",
  null
  
)

export default component.exports